import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: `0 ${theme.spacing(2)}px`,
      height: 42,
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(1),
      color: theme.palette.text.secondary,

      '& > * + *': {
        marginLeft: theme.spacing(2),
      },
    },
    filterButton: {
      minWidth: 'fit-content',
      textTransform: 'none',
      height: 22,
      paddingLeft: theme.spacing(0.75),
      paddingRight: theme.spacing(0.75),
    },
    skeleton: {
      transform: 'none',
    },
  }),
);
